// better-auth React client.
// Provides useSession(), signIn, signUp, signOut and all other auth methods.
// The baseURL must point to the backend origin; better-auth appends /api/auth
// automatically to construct the endpoint paths.
import { twoFactorClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

import { env } from '@/env'

export const authClient = createAuthClient({
  baseURL: env.VITE_APP_URL,
  fetchOptions: { credentials: 'include' },
  plugins: [twoFactorClient()],
})
